/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminUpdateSociety
 */
export interface AdminUpdateSociety {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    readableName: string;
    /**
     * 
     * @type {Blob}
     * @memberof AdminUpdateSociety
     */
    logo?: Blob;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    website?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    portal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    address?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUpdateSociety
     */
    additionalTerritories?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    formEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    formPostalAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    formPortal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    formReminderFrequency?: AdminUpdateSocietyFormReminderFrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    formStopReminderFrequency?: AdminUpdateSocietyFormStopReminderFrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    formReminderSendTo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    taxForms?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    roleForms?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateSociety
     */
    contactInformation?: string;
}


/**
 * @export
 */
export const AdminUpdateSocietyFormReminderFrequencyEnum = {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Yearly: 'Yearly'
} as const;
export type AdminUpdateSocietyFormReminderFrequencyEnum = typeof AdminUpdateSocietyFormReminderFrequencyEnum[keyof typeof AdminUpdateSocietyFormReminderFrequencyEnum];

/**
 * @export
 */
export const AdminUpdateSocietyFormStopReminderFrequencyEnum = {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Yearly: 'Yearly'
} as const;
export type AdminUpdateSocietyFormStopReminderFrequencyEnum = typeof AdminUpdateSocietyFormStopReminderFrequencyEnum[keyof typeof AdminUpdateSocietyFormStopReminderFrequencyEnum];


/**
 * Check if a given object implements the AdminUpdateSociety interface.
 */
export function instanceOfAdminUpdateSociety(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "readableName" in value;

    return isInstance;
}

export function AdminUpdateSocietyFromJSON(json: any): AdminUpdateSociety {
    return AdminUpdateSocietyFromJSONTyped(json, false);
}

export function AdminUpdateSocietyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUpdateSociety {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'readableName': json['readable_name'],
        'logo': !exists(json, 'logo') ? undefined : json['logo'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'website': !exists(json, 'website') ? undefined : json['website'],
        'portal': !exists(json, 'portal') ? undefined : json['portal'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'additionalTerritories': !exists(json, 'additional_territories') ? undefined : json['additional_territories'],
        'formEmail': !exists(json, 'form_email') ? undefined : json['form_email'],
        'formPostalAddress': !exists(json, 'form_postal_address') ? undefined : json['form_postal_address'],
        'formPortal': !exists(json, 'form_portal') ? undefined : json['form_portal'],
        'formReminderFrequency': !exists(json, 'form_reminder_frequency') ? undefined : json['form_reminder_frequency'],
        'formStopReminderFrequency': !exists(json, 'form_stop_reminder_frequency') ? undefined : json['form_stop_reminder_frequency'],
        'formReminderSendTo': !exists(json, 'form_reminder_send_to') ? undefined : json['form_reminder_send_to'],
        'taxForms': !exists(json, 'tax_forms') ? undefined : json['tax_forms'],
        'roleForms': !exists(json, 'role_forms') ? undefined : json['role_forms'],
        'contactInformation': !exists(json, 'contact_information') ? undefined : json['contact_information'],
    };
}

export function AdminUpdateSocietyToJSON(value?: AdminUpdateSociety | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'readable_name': value.readableName,
        'logo': value.logo,
        'country': value.country,
        'website': value.website,
        'portal': value.portal,
        'phone': value.phone,
        'address': value.address,
        'additional_territories': value.additionalTerritories,
        'form_email': value.formEmail,
        'form_postal_address': value.formPostalAddress,
        'form_portal': value.formPortal,
        'form_reminder_frequency': value.formReminderFrequency,
        'form_stop_reminder_frequency': value.formStopReminderFrequency,
        'form_reminder_send_to': value.formReminderSendTo,
        'tax_forms': value.taxForms,
        'role_forms': value.roleForms,
        'contact_information': value.contactInformation,
    };
}

